import { useMemo } from 'react';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { LookupType } from '@work4all/models/lib/Enums/LookupType.enum';
import {
  COLUMNS_BY_LOOKUP_TYPE,
  COLUMNS_BY_LOOKUP_TYPE_DEFINITIONS,
} from '@work4all/models/lib/lookup-field-definitions';
import { ITableColumnConfig } from '@work4all/models/lib/table-schema/table-schema';

export const useLookUpTableSchema = (lookupType: LookupType) => {
  return useMemo(() => {
    const lookUpTableColumns: ITableColumnConfig[] = [
      {
        id: 'name',
        title: ['COMMON.NAME'],
        accessor: 'name',
        sortable: false,
        groupable: false,
        path: [],
        filterable: {
          type: 'Search',
          primary: false,
        },
        quickSearchable: true,
        defaultHidden: false,
        width: 300,
        cell: {
          type: 'Text',
        },
      },
    ];

    const additionalColumns = COLUMNS_BY_LOOKUP_TYPE[lookupType] ?? [];
    // prefer to be injected and defined in some other place
    additionalColumns.forEach((column) => {
      lookUpTableColumns.push({
        id: column,
        title: `COMMON.${column?.toUpperCase()}`,
        accessor: column,

        sortable: false,
        groupable: false,
        filterable: false,
        quickSearchable: false,
        defaultHidden: false,
        width: 100,
        cell: {
          type: 'Text',
        },
        ...COLUMNS_BY_LOOKUP_TYPE_DEFINITIONS[column],
      });
    });

    return {
      entity: Entities.lookUp,
      columns: lookUpTableColumns,
      rowModifiers: [],
    };
  }, [lookupType]);
};
